import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import SubmitRepository from '../Repositories/SubmitRepository'


class SubmitBloc {

    submitChannel = new Subject();
    detailChannel = new Subject();
    repository = new SubmitRepository()
    typeChannel = new Subject()
    employeeChannel = new Subject();
    
   
   
    constructor() {
        this.submitChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmit = async (query) => {
        this.submitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmit(query).then((result) => {
            this.submitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.submitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchEmployee = async (query) => {
        this.employeeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailEmployee(query).then((result) => {
            this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.employeeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    
}

export default SubmitBloc